import React from "react";

import Corpo from "../components/Corpo";

export default function TabPerguntas(props) {
  return (
    <Corpo {...props}>
      <div name="tab-inicio" className="view-container tab-content">
        <div className="view-perguntas pane pane-game">
          <div
            className="scroll-content ionic-scroll  has-tabs-top"
            style={{ top: "56px" }}
          >
            <div
              className="scroll"
              style={{ transform: "translate3d(0px, 0px, 0px) scale(1)" }}
            >
              <h2>Minhas Perguntas</h2>
              <div
                className="content-table ng-hide"
                ng-show="mine.length"
                style={{}}
              >
                <header className="content-table-header">
                  <div className="row  row-center">
                    <div className="col col-75">Pergunta</div>
                    <div className="col">Status</div>
                  </div>
                </header>
                <div className="content-table-itens">
                  <div
                    direction="y"
                    style={{ height: "100%" }}
                    className="scroll-view ionic-scroll scroll-y"
                  >
                    <div className="scroll">
                      <div className="disable-user-behavior">
                        <div className="list"></div>
                      </div>
                    </div>
                    <div className="scroll-bar scroll-bar-v">
                      <div className="scroll-bar-indicator scroll-bar-fade-out" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row" ng-show="!mine.length">
                <div className="col">Sem perguntas enviadas.</div>
              </div>
              <h2>Perguntas de Outros Jogadores</h2>
              <div className="content-table ng-hide" ng-show="theirs.length">
                <header className="content-table-header">
                  <div className="row  row-center">
                    <div className="col col-67">Pergunta</div>
                    <div className="col">Visualizar</div>
                  </div>
                </header>
                <div className="content-table-itens">
                  <div
                    direction="y"
                    style={{ height: "100%" }}
                    className="scroll-view ionic-scroll scroll-y"
                  >
                    <div className="scroll">
                      <div className="disable-user-behavior">
                        <div className="list">
                          {/* ngRepeat: question in theirs */}
                        </div>
                      </div>
                    </div>
                    <div className="scroll-bar scroll-bar-v">
                      <div className="scroll-bar-indicator scroll-bar-fade-out" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row" ng-show="!theirs.length">
                <div className="col">Sem particiações de outros jogadores.</div>
              </div>
              <div className="col bottom-action-button">
                <a
                  ng-show="finshedSomeTheme"
                  href="#/tab/perguntas/criar"
                  className="button button-slim-inline ng-hide"
                  style={{}}
                >
                  Criar Pergunta
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Corpo>
  );
}
